<template>
  <div class="container-fluid">
    <ProductModal :productName="productName" :productPrice="productPrice" :productContent="productContent" :productImage="productImage" :hasProduct="hasProduct"/>
    <!-- 店家名稱與商品類別 -->
    <Navbar ref="Navbar" v-if="productsData" :productsData="productsData" :loadShopStatus="loadShopStatus" :navbarHeight="navbarHeight" />
    <!-- 商品列表 -->
    <Products ref="Products" v-if="productsData" :productsData="productsData" />
    <!-- 下方工具列，首頁、歷史、關注、結帳 -->
    <Checkout v-if="Shop" :Shop="Shop" />
  </div>
</template>

<script>
/* eslint-disable */
import { nextTick } from 'vue'
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'
import Modal from '@/components/Modal.vue'
import ProductModal from '@/components/Shop/ProductModal'
import Navbar from '@/components/Shop/Navbar'
import Products from '@/components/Shop/Products'
import Checkout from '@/components/Shop/Checkout'

import { getShopByShopId } from '@/Service/APIService'

export default {
  name: "Shop",
  components: { 
    Modal, 
    ProductModal,
    Navbar, 
    Products, 
    Checkout 
  },
  data() {
    return {
      Shop: Global.Shop,              // 店家資料
      shopId: this.$route.params.id,  // 店家ID
      productsData: null,             // 店家菜單
      Cart: [],                       // 購物車清單
      cartPrice: 0,                   // 購物金金額
      cartLength: 0,                  // 購物車商品數量
      activityContent: null,          // 活動敘述
      loadShopStatus: 0,              // 設定一個店家讀取時間，三秒
      navbarHeight: 0,
      /* 用於 ProductModal */
      productName: null,              // 商品名稱
      productPrice: null,             // 商品價格
      productImage: null,             // 商品圖片
      productContent: null,           // 商品敘述
      hasProduct: null,               // 是否有貨
    }
  },
  watch: {
    /* 偵測購物車變化，調整購物車金額及商品數量 */
    Cart: {
      handler: function () {
        this.$data.cartPrice = 0
        this.$data.cartLength = 0
        if (this.$data.Cart.length == 0) return false
        for (const i of this.$data.Cart[0].Data) this.$data.cartPrice += i.Price * i.Count
        for (const i of this.$data.Cart[0].Data) this.$data.cartLength += i.Count
      },
      deep: true
    }
  },
  methods: {
    /* 初始化，取得店家菜單 */
    init: async function() {
      await nextTick();
      /* 如果沒有店家id就退回首頁 */
      if (!this.$data.shopId) return this.$router.push({ name: "Home" })
      localStorage.setItem("lookAtShopById", this.$data.shopId)

      /* 如果有Token，就存到全域團購Token */
      if (this.$route.params.Token) {
        Global.GroupToken = this.$route.params.Token
        /* 如果團購時間已過，則跳轉 */
        if (Date.now() > Global.GroupToken * 1000) {
          this.$swal.fire({ icon: 'error', title: '團購已過期', text: '請重新整理頁面' })
          .then(() => { return this.$router.push({ name: "Home" }) })
        }
      }

      const params = { ShopJWT: localStorage.getItem("ShopJWT") }

      const response = await getShopByShopId(this.$data.shopId, params)

      /* 店家合約已到期，無法瀏覽 */
      if (response.data.Message == "SHOP_CONTRACT_STOP") {
        swal.alertError(Global.MESSAGE.SHOP.CONTRACT_STOP, () => { this.$router.push({ name: "Home" }) })
        return false
      }

      /* 這家店不是公開店家，沒有權限瀏覽 */
      if (response.data.Message == "NO_PREMISSIONS_ERROR") {
        swal.alertError(Global.MESSAGE.SHOP.NO_PREMISSIONS, () => { this.$router.push({ name: "Home" }) })
        return false
      }

      /* 店家資料 */
      this.$data.Shop = Global.Shop = response.data.Shop

      /* 店家菜單 */
      this.$data.productsData = response.data.productsData

      /* 建立或讀取購物車 (localstorage) */
      this.initCart()
      localStorage.getItem("Cart." + this.$data.shopId) ? this.loadCart() : null
    },
    /* 建立新的購物車 */
    initCart: function() {
      this.$data.Cart.push({ User: { userId: Global.User?.id || null }, Data: [] });
    },
    /* 讀取購物車 */
    loadCart: function() {
      const cartData = JSON.parse(localStorage.getItem("Cart." + this.$data.shopId)) || []
      this.$data.Cart[0].Data = cartData

      // 使用 Map 提高查找效率
      const productMap = new Map()

      this.$data.productsData.forEach(category => {
        category.Products.forEach(product => {
          productMap.set(product.id, product)
        })
      })

      // 直接更新 productKey 的 Count
      cartData.forEach(item => {
        const product = productMap.get(item.productId)
        if (product) product.Count = item.Count
      })
      // this.$data.Cart[0].Data = JSON.parse(localStorage.getItem("Cart." + this.$data.shopId))
      // for (const List of this.$data.Cart[0].Data) {
      //   for (const productCategoryKey of this.$data.productsData) {
      //     if (productCategoryKey.id == List.productCategoryId) {
      //       for (const productkey of productCategoryKey.Products) {
      //         if (productkey.id == List.productId) productkey.Count = List.Count
      //       }
      //     }
      //   }
      // }
    }
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    $("#ProductModal").modal('hide')
    $("#ProductItemModal").modal('hide')
    $("#StoreModal").modal('hide')
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  margin: 0px;
  padding: 0px;
  margin: auto;
  position: relative;
}
</style>